import { Component, Input } from '@angular/core';
import { TrackeritemRest } from '../../../services/trackeritem.rest';
import { PollService } from '../../../../../core/services/core.poll.service';
import { UiService } from '../../../../../core/services/core.ui.service';

@Component({
  selector: 'trackeritem-delete-modal',
  template: require('./trackeritem.delete.modal.component.html'),
})
export class TrackeritemDeleteModalComponent {
  @Input() trackeritem: any;
  @Input() onDelete: Function;
  @Input() onClose: Function;
  
  constructor(
    private trackeritemRest: TrackeritemRest,
    private pollService: PollService,
    private uiService: UiService
  ) {}

  doCancel(): void {
    this.onClose();
  }

  doDelete(): void {
    const delInProgressMsg = 'Delete in Progress';
    const delCompleteMsg = 'Delete complete';
    const delFailedMsg = 'Delete Failed';

    this.trackeritemRest.delete(0, this.trackeritem.id.toString())
      .then((response: any) => {
        const data = this.processPollMessages(response);
        if (data.bgJobId) {
          // delete request was backgrounded
          this.uiService.message.showWarning(delInProgressMsg);
          this.pollService.add('bgjob', 'backgroundjob', data.bgJobId, 0);
        } else {
          // delete completed, msg shown, load tracker
          this.uiService.message.showSuccess(`Tracker item ${this.trackeritem.id} deleted`, delCompleteMsg);
          this.onDelete(this.trackeritem);
        }
      }, (response: any) => {
        this.uiService.message.showError(response, delFailedMsg);
      })
      .then(() => {
        this.onClose();
      });
  }

  processPollMessages(pollResponse: any): any {
    const data = this.pollService.parseJobMessage(pollResponse);
    if (data.msgErr) {
      this.uiService.message.showWarning(data.msgOk + data.msgErr);
    } else {
      this.uiService.message.showSuccess(data.msgOk + data.msgErr);
    }
    return data;
  }
}
